import React, { ReactElement, useState } from "react";

import { FieldFilterDefinition } from "../../generated/gql/graphql";
import Filters from "../lists/filters";

import { GraphicList, GraphicListProps, GraphicListRef } from "./graphic-list";
import useGraphicFilters from "./use-graphic-filters";

export type GraphicsPanelProps = Pick<
  GraphicListProps,
  "handleGraphicClick" | "query" | "gridSize"
> & {
  graphicListRef: React.RefObject<GraphicListRef>;
};

export default function GraphicsPanel({
  handleGraphicClick,
  query,
  gridSize,
  graphicListRef,
}: GraphicsPanelProps): ReactElement {
  const { fieldFilters: availableFilters } = useGraphicFilters();

  const [activeFilters, setActiveFilters] = useState<FieldFilterDefinition[]>(
    [],
  );

  return (
    <>
      <Filters
        filters={availableFilters}
        onChangeFilters={setActiveFilters}
        selectedFilters={activeFilters}
      />
      <GraphicList
        ref={graphicListRef}
        query={query}
        filters={activeFilters}
        gridSize={gridSize}
        handleGraphicClick={handleGraphicClick}
      />
    </>
  );
}
